import React from "react";
import "./ChallengeCardComp.scss";
import checkRules from "../../../../Assets/Images/checkRules.svg";
import checkRulesLight from "../../../../Assets/Images/checkRulesLight.svg";
import { Button } from "Components/ui/button";
import { useTheme } from "hooks/ThemeContext";

function ChallengeCardComp({
  icon,
  type,
  title,
  subtitle,
  rules,
  btnText,
  disabled,
  onClick,
}) {
  const { theme } = useTheme();
  return (
    <div
      className="h-[27rem] p-4 rounded-xl border-2 border-border-darkNew w-full flex flex-col justify-between aspect-square"
      style={{
        background:
          theme === "dark"
            ? "linear-gradient(-140deg, #ffffff33 -100% , #000000)"
            : " white",
      }}
    >
      <div className="flex flex-col gap-3">
        {icon && <div>{icon}</div>}
        <div className="text-2xl">{title}</div>
        <div className="md:text-xs text-base opacity-50 -mt-2 md:mt-0">
          {subtitle}
        </div>
      </div>

      <div className="flex flex-col gap-2">
        <div className="text-2xl font-N_Bold mt-4">{type || "free"}</div>
        {rules.map((rule, index) => (
          <div key={index} className="flex items-center gap-2">
            <img
              src={theme === "dark" ? checkRules : checkRulesLight}
              alt="checkRules"
              className="h-6 "
            />
            <div className="text-[10px] opacity-50 mt-[0.1rem]">{rule}</div>
          </div>
        ))}
      </div>
      <Button
        disabled={disabled}
        className="w-full mt-6 py-0"
        onClick={() => {
          onClick();
        }}
      >
        {btnText}
      </Button>
    </div>
  );
}

export default ChallengeCardComp;
